<template>
  <div id="email" class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 mb2 ml4">
      <div class="col-12">
        <div class="clearfix">
          <div class="col-12 mt2 px0 flex justify-between items-center">
            <p class="h4 semi-bold line-height-2 my2">E-mail</p>
          </div>
          <div class="col-12 lg-col-5 px0 mb2">
            <div class="right-align mb3">
              <router-link to="/inbox" class="primarycolor">Beskeder</router-link>
            </div>
            <b-form v-model="loginForm" v-if="!isEmailLoggedIn">
              <div class="clearfix" v-if="loading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div v-else>
                <div class="flex items-center mb2">
                  <div class="col-9 p0">
                    <b-form-input ref="loginEmail" v-model="loginEmail" class="h5 p2" placeholder="E-mail"></b-form-input>
                  </div>
                  <div class="col-3 center p0">
                    <span class="primarycolor">{{loginEmailDomain}}</span>
                  </div>
                </div>
                <b-form-input type="password" ref="loginPassword" v-model="loginPassword" class="h5 p2 mb4" placeholder="Password"></b-form-input>
                <button type="button" class="btn rounded action-button btn-lg col-12" @click="login()">
                  Login
                </button>
              </div>
            </b-form>
            <div class="py2" v-else>
              <div class="mb3" v-if="inputSearchVisible">
                <b-form-input placeholder="Søg email" v-model="search" class="search"></b-form-input>
              </div>
              <el-tabs v-model="activeTab" class="gibson" @tab-click="tabChanged">
                <el-tab-pane name="1">
                  <span slot="label"><i class="el-icon-download mr1"></i> Inbox</span>
                  <div class="clearfix" v-if="insideLoading">
                    <div class="col-12">
                      <div class="loader"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="col-12 py2">
                      <a class="h4 pointer auto-reload" title="Genindlæs"><i class="el-icon-refresh-right mediumgrey" @click="autoReload()"></i></a>
                      <div class="flex justify-between">
                        <div>
                          <input id="chkbxSelect" class="mr2" type="checkbox" @click="checkboxSelectDeselectAll()">
                          <span class="mark-as" style="visibility: hidden;">
                            <a class="h4 mr2 pointer" title="Marker som læst" @click="markAsRead()"><i class="far fa-envelope-open mediumgrey"></i></a>
                            <a class="h4 pointer" title="Marker som ulæst" @click="markAsUnread()"><i class="far fa-envelope mediumgrey"></i></a>
                          </span>
                        </div>
                        <div>
                          <el-pagination
                            class="regular"
                            small
                            layout="prev, pager, next"
                            :total="parseInt(lastPage)" @current-change="paginationChanged" :current-page="parseInt(curPage)">
                          </el-pagination>
                        </div>
                      </div>
                    </div>
                    <div :class="'mail-'+mail.Uid+' read-'+mail.IsSeen" v-for="(mail, index) in emailData['@Collection']" :key="index">
                      <div class="flex flex-column pt2 pb2 border-top muted-border mouse-cursor">
                        <div class="col-12 flex gibson">
                          <div class="col-1 p0">
                            <input class="chkbx" type="checkbox" :value="mail.Uid" @click="checkboxChanged()">
                          </div>
                          <div class="col-11 flex justify-between items-start p0 pointer" @click="showEmailDetails('inbox', mail.Uid, mail.IsSeen)">
                            <div>
                              <span class="h6 regular mediumgrey-text line-height-3 m0" v-if="mail.From['@Collection'][0].DisplayName != ''">
                                {{mail.From['@Collection'][0].DisplayName}}
                              </span>
                              <span class="h6 regular mediumgrey-text line-height-3 m0" v-else>
                                {{mail.From['@Collection'][0].Email}}
                              </span>
                              <p class="mediumgrey line-height-3 m0" style="font-size:.875rem;" v-if="mail.Subject != ''">{{mail.Subject}}</p>
                              <p class="mediumgrey line-height-3 m0" style="font-size:.875rem;" v-else>No Subject</p>
                            </div>
                            <div>
                              <p class="h6 regular mediumgrey-text line-height-3">
                                {{moment(new Date(parseInt(mail.TimeStampInUTC * 1000))).format('Do MMMM YYYY')}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="py2 px2">
                      <span class="mediumgrey">{{emailMsg}}</span>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="2">
                  <span slot="label"><i class="el-icon-upload2 mr1"></i> Sendte</span>
                  <div class="clearfix" v-if="insideLoading">
                    <div class="col-12">
                      <div class="loader"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="col-12 py2">
                      <el-pagination
                        class="regular right-align"
                        small
                        layout="prev, pager, next"
                        :total="parseInt(lastPage)" @current-change="paginationChanged" :current-page="parseInt(curPage)">
                      </el-pagination>
                    </div>
                    <div :class="'mail-'+mail.Uid+' read-'+mail.IsSeen" v-for="(mail, index) in emailData['@Collection']" :key="index">
                      <div class="flex flex-column pt2 pb2 border-top muted-border mouse-cursor pointer" @click="showEmailDetails('sent', mail.Uid, mail.IsSeen)">
                        <div class="col-12 flex justify-between items-start gibson">
                          <div>
                            <span class="h6 regular mediumgrey-text line-height-3 m0">
                              Me
                            </span>
                            <p class="mediumgrey line-height-3 m0" style="font-size:.875rem;" v-if="mail.Subject != ''">{{mail.Subject}}</p>
                            <p class="mediumgrey line-height-3 m0" style="font-size:.875rem;" v-else>No Subject</p>
                          </div>
                          <div>
                            <p class="h6 regular mediumgrey-text line-height-3">
                              {{moment(new Date(parseInt(mail.TimeStampInUTC * 1000))).format('Do MMMM YYYY')}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="py2 px2">
                      <span class="mediumgrey">{{emailMsg}}</span>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="3">
                  <span slot="label"><i class="el-icon-plus mr1"></i> Komponer</span>
                  <div class="clearfix">
                    <b-form @submit.stop.prevent="" id="formSubmit">
                      <div class="clearfix mt3">
                        <div class="mb3">
                          <div class="right-align pointer">
                            <span class="h6 regular darkblue mr1 mb1" @click="showRecipient('CC')" v-if="!recipientCCVisible">CC</span>
                            <span class="h6 regular darkblue mb1" @click="showRecipient('BCC')" v-if="!recipientBCCVisible">BCC</span>
                          </div>
                          <div>
                            <span class="h5 regular darkblue mb1">Til:</span>
                          </div>
                          <el-tag
                            v-for="(recipient, index) in recipientTo"
                            :key="index"
                            closable
                            :disable-transitions="false"
                            @close="removeRecipient(recipient, 'to')"
                            class="h6 white-background mr1">
                            <span>{{recipient}}</span>
                          </el-tag>
                          <div v-if="inputRecipientToVisible">
                            <b-form-input
                              list="contactList"
                              class="h5 p2 input-new-to"
                              v-model="inputRecipientTo"
                              ref="saveRecipientTo"
                              autocomplete="off"
                              @change="addRecipient('to')"
                              @blur="addRecipient('to')">
                            </b-form-input>
                            <datalist id="contactList">
                              <option v-for="contact in contactsData.List">{{ contact.ViewEmail }}</option>
                            </datalist>
                          </div>
                          <b-button v-else class="border circle darkblue white-background button-new-tag" @click="showInputRecipient('to')" style="width: 40px;height: 40px;">+</b-button>
                        </div>
                        <div class="mb3" v-if="recipientCCVisible">
                          <div class="h5 regular darkblue mb1">CC:</div>
                          <el-tag
                            v-for="(recipient, index) in recipientCC"
                            :key="index"
                            closable
                            :disable-transitions="false"
                            @close="removeRecipient(recipient, 'CC')"
                            class="h6 white-background mr1">
                            <span>{{recipient}}</span>
                          </el-tag>
                          <div v-if="inputRecipientCCVisible">
                            <b-form-input
                              list="contactList"
                              class="h5 p2 input-new-cc"
                              v-model="inputRecipientCC"
                              ref="saveRecipientCC"
                              autocomplete="off"
                              @change="addRecipient('CC')"
                              @blur="addRecipient('CC')">
                            </b-form-input>
                            <datalist id="contactList">
                              <option v-for="contact in contactsData.List">{{ contact.ViewEmail }}</option>
                            </datalist>
                          </div>
                          <b-button v-else class="border circle darkblue white-background button-new-tag" @click="showInputRecipient('CC')" style="width: 40px;height: 40px;">+</b-button>
                        </div>
                        <div class="mb3" v-if="recipientBCCVisible">
                          <div class="h5 regular darkblue mb1">BCC:</div>
                          <el-tag
                            v-for="(recipient, index) in recipientBCC"
                            :key="index"
                            closable
                            :disable-transitions="false"
                            @close="removeRecipient(recipient, 'BCC')"
                            class="h6 white-background mr1">
                            <span>{{recipient}}</span>
                          </el-tag>
                          <div v-if="inputRecipientBCCVisible">
                            <b-form-input
                              list="contactList"
                              class="h5 p2 input-new-bcc"
                              v-model="inputRecipientBCC"
                              ref="saveRecipientBCC"
                              autocomplete="off"
                              @change="addRecipient('BCC')"
                              @blur="addRecipient('BCC')">
                            </b-form-input>
                            <datalist id="contactList">
                              <option v-for="contact in contactsData.List">{{ contact.ViewEmail }}</option>
                            </datalist>
                          </div>
                          <b-button v-else class="border circle darkblue white-background button-new-tag" @click="showInputRecipient('BCC')" style="width: 40px;height: 40px;">+</b-button>
                        </div>
                        <div class="flex flex-column mb3">
                          <span class="h5 regular darkblue mb1">Emne:</span>
                          <b-form-input id="title" class="not-rounded p2 darkblue h5 gibson" v-model="subject"></b-form-input>
                        </div>
                        <!-- response -->
                        <div class="flex flex-column mb3">
                          <span class="h5 regular darkblue mb1"></span>
                          <wysiwyg placeholder="Besked" required v-model="message"/>
                        </div>
                      </div>
                      <div class="clearfix">
                        <button type="submit" class="send-btn col-12 action-button p2 gibson h4 not-rounded border-none" @click="sendEmail()">
                          <span class="regular">Send</span>
                        </button>
                      </div>
                    </b-form>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="4">
                  <span slot="label"><i class="el-icon-user mr1"></i> Kontakter</span>
                  <div class="clearfix" v-if="insideLoading">
                    <div class="col-12">
                      <div class="loader"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="col-12 p0 py2">
                      <div class="add-update-contact mb1">
                        <a class="h5 mr2 pointer" title="Tilføj kontakt" @click="showContactForm('add', '')"><span class="green"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19.5 15c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5zm2.5 5h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1zm-7.18 4h-14.815l-.005-1.241c0-2.52.199-3.975 3.178-4.663 3.365-.777 6.688-1.473 5.09-4.418-4.733-8.729-1.35-13.678 3.732-13.678 6.751 0 7.506 7.595 3.64 13.679-1.292 2.031-2.64 3.63-2.64 5.821 0 1.747.696 3.331 1.82 4.5z"/></svg></span></a>
                      </div>
                      <table class="el-table__body col-12 p0" v-if="contactsData.ContactCount > 0">
                        <thead class="has-gutter">
                          <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Navn</th>
                          <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">E-mail</th>
                        </thead>
                        <tbody>
                          <tr class="el-table__row border-top muted-border" v-for="(contacts, index) in contactsData.List" :key="index">
                            <td class="el-table_1_column_1 mediumgrey-text py2">{{contacts.FullName}}</td>
                            <td class="el-table_1_column_1 mediumgrey-text py2">{{contacts.ViewEmail}}</td>
                            <td class="add-update-contact relative"><span class="absolute right-0" style="top:20px;"><a class="h5 yellow pointer mr1" title="Opdatering" @click="showContactForm('update', contacts)"><i class="el-icon-edit"></i></a><a class="h5 red pointer" title="Slet" v-confirm="{ok: confirmDeleteContact(contacts.UUID)}"><i class="el-icon-delete"></i></a></span></td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else>
                        <span class="mediumgrey">Ingen kontakter.</span>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
              <el-dialog
                class="email-dialog"
                :visible.sync="emailDetailsDialog"
                width="40%"
                left
                v-if="emailDetailsDialog">
                <div class="clearfix" v-if="emailLoading">
                  <div class="col-12">
                    <div class="loader"></div>
                  </div>
                </div>
                <div class="email-content hide">
                  <div class="left-align mb3">
                    <span id="textSubject" class="h2 darkblue block mb2" v-if="emailDetailsData.Subject != ''">{{emailDetailsData.Subject}}</span>
                    <span id="textSubject" class="h2 mediumgrey-text block mb2" v-else>No Subject</span>
                    <div class="flex justify-between">
                      <div>
                        <el-tooltip :content="emailDetailsData.From['@Collection'][0].Email" placement="bottom" effect="light" :open-delay="500">
                          <span class="h5 darkblue" v-if="emailDetailsData.From['@Collection'][0].DisplayName != ''">
                            <span v-if="emailDetailsData.From['@Collection'][0].Email == loginEmail">Me</span>
                            <span v-else>{{emailDetailsData.From['@Collection'][0].DisplayName}}</span>
                          </span>
                          <span class="h5 darkblue" v-else>
                            <span v-if="emailDetailsData.From['@Collection'][0].Email == loginEmail">Me</span>
                            <span v-else>{{emailDetailsData.From['@Collection'][0].Email}}</span>
                          </span>
                        </el-tooltip>
                      </div>
                      <div>
                        <p class="h6 regular mediumgrey-text line-height-3">
                          {{new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(emailDetailsData.TimeStampInUTC * 1000).slice(0, -5).replace(' at', ',')}}
                        </p>
                      </div>
                    </div>
                    <p class="recipient mediumgrey mb2">to
                      <span class="recipient-to" v-if="emailDetailsData.To != null">
                        <el-tooltip :content="mail.Email" placement="bottom" effect="light" :open-delay="500" v-for="(mail, index) in emailDetailsData.To['@Collection']" :key="index" v-if="index >= 1" style="margin-left: -0.2em;">
                          <span v-if="mail.DisplayName != ''">
                            <span v-if="mail.Email == loginEmail">, Me</span>
                            <span v-else>, {{mail.DisplayName}}</span>
                          </span>
                          <span v-else>
                            <span v-if="mail.Email == loginEmail">, Me</span>
                            <span v-else>, {{mail.Email}}</span>
                          </span>
                        </el-tooltip>
                        <el-tooltip :content="mail.Email" placement="bottom" effect="light" :open-delay="500" v-for="(mail, index) in emailDetailsData.To['@Collection']" :key="index" v-else>
                          <span v-if="mail.DisplayName != ''">
                            <span v-if="mail.Email == loginEmail">Me</span>
                            <span v-else>{{mail.DisplayName}}</span>
                          </span>
                          <span v-else>
                            <span v-if="mail.Email == loginEmail">Me</span>
                            <span v-else>{{mail.Email}}</span>
                          </span>
                        </el-tooltip>
                      </span>
                      <span class="recipient-cc" v-if="emailDetailsData.Cc != null">
                        <el-tooltip :content="mail.Email" placement="bottom" effect="light" :open-delay="500" v-for="(mail, index) in emailDetailsData.Cc['@Collection']" :key="index" style="margin-left: -0.2em;">
                          <span v-if="mail.DisplayName != ''">
                            <span v-if="mail.Email == loginEmail">, Me</span>
                            <span v-else>, {{mail.DisplayName}}</span>
                          </span>
                          <span v-else>
                            <span v-if="mail.Email == loginEmail">, Me</span>
                            <span v-else>, {{mail.Email}}</span>
                          </span>
                        </el-tooltip>
                      </span>
                    </p>
                    <p class="email-text" v-html="emailDetailsData.HtmlRaw"></p>
                  </div>
                  <div class="clearfix">
                    <b-form @submit.stop.prevent="" id="formSubmit" v-if="responseForm">
                      <div class="clearfix mt3">
                        <div class="mb3">
                          <div class="right-align pointer">
                            <span class="h6 regular darkblue mr1 mb1" @click="showRecipient('CC')" v-if="!recipientCCVisible">CC</span>
                            <span class="h6 regular darkblue mb1" @click="showRecipient('BCC')" v-if="!recipientBCCVisible">BCC</span>
                          </div>
                          <div>
                            <span class="h6 darkblue mb1">Til:</span>
                          </div>
                          <el-tag
                            closable
                            :disable-transitions="false"
                            @close="removeRecipient(recipient, 'to')"
                            class="h6 darkblue regular white-background mr1"
                            v-for="(recipient, index) in recipientTo" :key="index">
                            <span>{{recipient}}</span>
                          </el-tag>
                          <div v-if="inputRecipientToVisible">
                            <b-form-input
                              list="contactList"
                              class="h5 p2 input-new-to"
                              v-model="inputRecipientTo"
                              ref="saveRecipientTo"
                              autocomplete="off"
                              @change="addRecipient('to')"
                              @blur="addRecipient('to')">
                            </b-form-input>
                            <datalist id="contactList">
                              <option v-for="contact in contactsData.List">{{ contact.ViewEmail }}</option>
                            </datalist>
                          </div>
                          <b-button v-else class="border circle darkblue white-background button-new-tag" @click="showInputRecipient('to')" style="width: 40px;height: 40px;">+</b-button>
                        </div>
                        <div class="mb3" v-if="recipientCCVisible">
                          <div class="h6 darkblue mb1">CC:</div>
                          <el-tag
                            closable
                            :disable-transitions="false"
                            @close="removeRecipient(recipient, 'CC')"
                            class="h6 darkblue regular white-background mr1"
                            v-for="(recipient, index) in recipientCC" :key="index">
                            <span>{{recipient}}</span>
                          </el-tag>
                          <div v-if="inputRecipientCCVisible">
                            <b-form-input
                              list="contactList"
                              class="h5 p2 input-new-cc"
                              v-model="inputRecipientCC"
                              ref="saveRecipientCC"
                              autocomplete="off"
                              @change="addRecipient('CC')"
                              @blur="addRecipient('CC')">
                            </b-form-input>
                            <datalist id="contactList">
                              <option v-for="contact in contactsData.List">{{ contact.ViewEmail }}</option>
                            </datalist>
                          </div>
                          <b-button v-else class="border circle darkblue white-background button-new-tag" @click="showInputRecipient('CC')" style="width: 40px;height: 40px;">+</b-button>
                        </div>
                        <div class="mb3" v-if="recipientBCCVisible">
                          <div class="h6 darkblue mb1">BCC:</div>
                          <el-tag
                            closable
                            :disable-transitions="false"
                            @close="removeRecipient(recipient, 'BCC')"
                            class="h6 white-background mr1"
                            v-for="(recipient, index) in recipientBCC" :key="index">
                            <span>{{recipient}}</span>
                          </el-tag>
                          <div v-if="inputRecipientBCCVisible">
                            <b-form-input
                              list="contactList"
                              class="h5 p2 input-new-bcc"
                              v-model="inputRecipientBCC"
                              ref="saveRecipientBCC"
                              autocomplete="off"
                              @change="addRecipient('BCC')"
                              @blur="addRecipient('BCC')">
                            </b-form-input>
                            <datalist id="contactList">
                              <option v-for="contact in contactsData.List">{{ contact.ViewEmail }}</option>
                            </datalist>
                          </div>
                          <b-button v-else class="border circle darkblue white-background button-new-tag" @click="showInputRecipient('BCC')" style="width: 40px;height: 40px;">+</b-button>
                        </div>
                        <!-- response -->
                        <div class="flex flex-column mb3">
                          <span class="h5 regular darkblue mb1"></span>
                          <wysiwyg placeholder="Besked" ref="test" v-model="message" />
                        </div>
                      </div>
                    </b-form>
                  </div>
                  <span slot="footer" class="dialog-footer flex justify-between">
                    <div class="">
                      <div v-if="buttonResponseVisible">
                        <b-btn type="button" class="rounded mr1" variant="success" size="lg"  @click="showReplyEmail('reply', emailDetailsData)">
                          <span class="mr2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"/></svg></span>Reply
                        </b-btn>
                         <b-btn type="button" class="rounded mr1" variant="success" size="lg"  @click="showReplyEmail('replyAll', emailDetailsData)" v-if="emailDetailsData.Cc != null">
                          <span class="mr2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"/></svg></span>Reply Alle
                        </b-btn>
                         <b-btn type="button" class="rounded" variant="success" size="lg"  @click="showReplyEmail('forward', emailDetailsData)" v-if="emailDetailsData.Cc != null">
                          <span class="mr2"><<i class="el-icon-share"></i></span>Frem
                        </b-btn>
                        <b-btn type="button" class="rounded" variant="success" size="lg"  @click="showReplyEmail('forward', emailDetailsData)" v-else>
                          <span class="mr2"><<i class="el-icon-share"></i></span>Frem
                        </b-btn>
                      </div>
                      <b-btn type="button" class="send-btn action-button rounded" variant="success" size="lg"  @click="sendEmail()" v-else>Send
                      </b-btn>
                    </div>
                    <div class="">
                      <b-btn type="buttom" variant="secondary" size="lg" class="standard-button rounded" @click="closeEmailDetails">
                        Luk
                      </b-btn>
                    </div>
                    <!-- <b-button @click="centerDialogVisible = false">Cancel</b-button>
                    <b-button type="primary" @click="centerDialogVisible = false">Confirm</b-button> -->
                  </span>
                </div>
              </el-dialog>
              <el-dialog
                class="email-dialog"
                :visible.sync="emailLoadingDialog"
                width="40%"
                left
                v-if="emailLoadingDialog">
                <div class="clearfix">
                  <div class="col-12">
                    <div class="loader"></div>
                  </div>
                </div>
              </el-dialog>
              <el-dialog
                class="contact-dialog"
                title="Tilføj kontakt"
                :visible.sync="contactsAddFormDialog"
                width="40%"
                left
                v-if="contactsAddFormDialog">
                <div>
                  <b-form v-model="contactForm">
                    <div class="mb3">
                      <span class="h5 regular darkblue mb1">Navn:</span>
                      <b-form-input class="h5 p2" v-model="contactName"></b-form-input>
                    </div>
                    <div class="mb3">
                      <span class="h5 regular darkblue mb1">E-mail:</span>
                      <b-form-input class="h5 p2" v-model="contactEmail"></b-form-input>
                    </div>
                  </b-form>
                </div>
                <span slot="footer" class="dialog-footer flex justify-between">
                  <div class="">
                    <b-btn type="button" class="send-btn action-button rounded" variant="success" size="lg" @click="addContact()">Tilføje
                    </b-btn>
                  </div>
                  <div class="">
                    <b-btn type="buttom" variant="secondary" size="lg" class="standard-button rounded" @click="closeContactForm('add')">
                      Luk
                    </b-btn>
                  </div>
                </span>
              </el-dialog>
              <el-dialog
                class="contact-dialog"
                title="Opdater kontakt"
                :visible.sync="contactsUpdateFormDialog"
                width="40%"
                left
                v-if="contactsUpdateFormDialog">
                <div>
                  <b-form v-model="contactForm">
                    <div class="mb3">
                      <span class="h5 regular darkblue mb1">Navn:</span>
                      <b-form-input class="h5 p2" v-model="contactName"></b-form-input>
                    </div>
                    <div class="mb3">
                      <span class="h5 regular darkblue mb1">E-mail:</span>
                      <b-form-input class="h5 p2" v-model="contactEmail"></b-form-input>
                    </div>
                  </b-form>
                </div>
                <span slot="footer" class="dialog-footer flex justify-between">
                  <div class="">
                    <b-btn type="button" class="send-btn action-button rounded" variant="success" size="lg" @click="updateContact()">Opdatering
                    </b-btn>
                  </div>
                  <div class="">
                    <b-btn type="buttom" variant="secondary" size="lg" class="standard-button rounded" @click="closeContactForm('update')">
                      Luk
                    </b-btn>
                  </div>
                </span>
              </el-dialog>
              <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import vSelect from 'vue-select'
import axios from 'axios'
export default {
  components: {
    Simplert,
    vSelect
  },
  data () {
    return {
      loading: false,
      insideLoading: true,
      isEmailLoggedIn: false,
      loginForm: '',
      loginEmail: '',
      loginEmailDomain: '@jobcatcher.dk',
      loginPassword: '',
      accountID: '',
      search: '',
      inputSearchVisible: true,
      curPage: 1,
      limit: 20,
      offset: 0,
      loadedEmail: 20,
      lastPage: 50,
      totalEmailCount: 0,
      activeTab: '1',
      emailData: [],
      emailMsg: '',
      imgSrcData: [],
      emailDetailsData: [],
      emailLoadingDialog: false,
      emailLoading: true,
      emailDetailsDialog: false,
      responseForm: false,
      subject: '',
      message: '',
      recipientTo: [],
      inputRecipientToVisible: false,
      inputRecipientTo: '',
      recipientCC: [],
      recipientCCVisible: false,
      inputRecipientCCVisible: false,
      inputRecipientCC: '',
      recipientBCC: [],
      recipientBCCVisible: false,
      inputRecipientBCCVisible: true,
      inputRecipientBCC: '',
      buttonResponseVisible: true,
      contactsData: [],
      contactsAddFormDialog: false,
      contactsUpdateFormDialog: false,
      contactForm: '',
      contactName: '',
      contactEmail: '',
      contactUuid: ''
    }
  },
  created () {
    const isEmailLoggedIn = localStorage.getItem('isEmailLoggedIn')
    const emailAccountId = localStorage.getItem('emailAccountId')
    if (isEmailLoggedIn === 'true') {
      this.isEmailLoggedIn = true
      this.accountID = emailAccountId
      const seshEmail = sessionStorage.getItem('email')
      if (seshEmail !== null) {
        this.getEmailCount()
      } else {
        this.isEmailLoggedIn = false
      }
    } else {
      setTimeout(() => {
        this.$refs.loginEmail.focus()
      }, 1000)
    }
  },
  methods: {
    login () {
      const email = this.loginEmail
      const password = this.loginPassword
      if (email !== '' && password !== '') {
        // Check credentials
        axios({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/login',
          data: {
            login: email + this.loginEmailDomain,
            password: password
          }
        }).then(response => {
          var res = response.data
          if (res.success) {
            this.isEmailLoggedIn = true
            localStorage.setItem('isEmailLoggedIn', true)
            // For contacts
            sessionStorage.setItem('email', email + this.loginEmailDomain)
            sessionStorage.setItem('password', password)
            // Get account id
            axios({
              method: 'POST',
              url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getAccounts',
              data: {
                login: email + this.loginEmailDomain,
                password: password
              }
            }).then(response => {
              var res = response.data
              if (res.success) {
                for (var i = 0; i < res.data.length; i++) {
                  if (res.data[i].Email === email + this.loginEmailDomain) {
                    this.accountID = res.data[i].AccountID
                    localStorage.setItem('emailAccountId', res.data[i].AccountID)
                    this.getEmailCount()
                  }
                }
              }
            }).catch(err => {
              console.log(err)
            })
            this.loading = false
          }
        }).catch(err => {
          console.log(err)
          this.loginPassword = ''
          this.$toastr('error', 'Ugyldigt login')
          this.loading = false
        })
        this.loading = true
      } else {
        this.$refs.loginEmail.focus()
        this.$toastr('error', 'Felter påkrævet')
      }
    },
    autoReload () {
      this.getEmailCount()
    },
    getEmailCount () {
      const accId = this.accountID
      var emailFolder = ''
      const email = sessionStorage.getItem('email')
      const password = sessionStorage.getItem('password')
      if (this.activeTab === '1') {
        emailFolder = 'Inbox'
      } else if (this.activeTab === '2') {
        emailFolder = 'Sent'
      }
      // Get email count
      axios({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getMessages',
        data: {
          account_id: accId,
          folder: emailFolder,
          login: email,
          password: password
        }
      }).then(response => {
        var res = response.data
        if (res.success) {
          var subjectList = []
          var count = 0
          for (var i = 0; i < res.data['@Collection'].length; i++) {
            var uid = res.data['@Collection'][i].Uid
            var subject = res.data['@Collection'][i].Subject
            if (!subjectList.includes(subject)) {
              subjectList.push(subject)
              count++
            } else {
              this.deleteEmail(uid)
            }
          }
          this.totalEmailCount = count
          // Get last page
          const emailCount = count
          const limit = this.limit
          var lastPage = 0
          lastPage = emailCount / limit
          if (!Number.isInteger(lastPage)) {
            var data = lastPage.toString().split('.')
            if (parseInt(data[1]) > 0) {
              this.lastPage = parseInt(data[0]) + 1 + '0'
            } else {
              this.lastPage = parseInt(data[0]) + '0'
            }
          } else {
            this.lastPage = lastPage + '0'
          }
          this.calculatePagination()
          this.displayEmail(emailFolder)
        }
      }).catch(err => {
        console.log(err)
      })
      this.insideLoading = true
    },
    calculatePagination () {
      const emailCount = this.totalEmailCount
      const limit = this.limit
      var loadedEmail = this.limit
      const curPage = this.curPage
      console.log(curPage)
      var offset = 0
      if (curPage === 1) {
        offset = emailCount - limit
        this.offset = offset
      } else {
        this.loadedEmail = loadedEmail * curPage
        this.offset = this.loadedEmail - this.limit
      }
      console.log(this.offset)
    },
    paginationChanged (val) {
      var curPage = parseInt((`${val}`))
      this.curPage = curPage
      this.getEmailCount()
      this.insideLoading = true
    },
    displayEmail (folder) {
      const accId = this.accountID
      const emailFolder = folder
      const search = this.search
      const limit = this.limit
      const offset = this.offset
      const email = sessionStorage.getItem('email')
      const password = sessionStorage.getItem('password')
      // if (offset < limit) {
      //   limit = limit - offset
      //   offset = 0
      // }
      // Get emails
      axios({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getMessages',
        data: {
          account_id: accId,
          folder: emailFolder,
          search: search,
          limit: limit,
          offset: offset,
          login: email,
          password: password
        }
      }).then(response => {
        var res = response.data
        if (res.success) {
          this.emailData = res.data
          this.displayContacts()
          this.insideLoading = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    sendEmail () {
      const accId = this.accountID
      var to = ''
      for (var i = 0; i < this.recipientTo.length; i++) {
        if (i > 0) {
          to += ',' + this.recipientTo[i]
        } else {
          to += this.recipientTo[i]
        }
      }
      var cc = ''
      for (var j = 0; j < this.recipientCC.length; j++) {
        if (j > 0) {
          cc += ',' + this.recipientCC[j]
        } else {
          cc += this.recipientCC[j]
        }
      }
      var bcc = ''
      for (var k = 0; k < this.recipientBCC.length; k++) {
        if (k > 0) {
          bcc += ',' + this.recipientBCC[k]
        } else {
          bcc += this.recipientBCC[k]
        }
      }
      const subject = this.subject
      const text = this.message
      const email = sessionStorage.getItem('email')
      const password = sessionStorage.getItem('password')
      if (to !== '' && text !== '') {
        axios({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/sendMessage',
          data: {
            account_id: accId,
            to: to,
            cc: cc,
            bcc: bcc,
            subject: subject,
            text: text,
            login: email,
            password: password
          }
        }).then(response => {
          var res = response.data
          if (res.success) {
            this.enableSendButton()
            this.clear()
            this.closeEmailDetails()
            if (this.activeTab === '1') {
              this.displayEmail('Inbox')
            } else if (this.activeTab === '2') {
              this.displayEmail('Sent')
            }

            this.inputRecipientToVisible = true
            let obj = {
              title: 'Besked sendt!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          }
        }).catch(err => {
          document.querySelector('.send-btn').classList.remove('disabled')
          console.log(err)
          this.$toastr('error', 'Meddelelsen blev ikke sendt')
        })
        this.disableSendButton()
      } else {
        this.$toastr('error', 'Felter påkrævet')
      }
    },
    showEmailDetails (mail, Uid, IsSeen) {
      var folder = ''
      if (mail === 'inbox') {
        folder = 'Inbox'
      } else if (mail === 'sent') {
        folder = 'Sent'
      }
      const accId = this.accountID
      const uId = Uid
      const email = sessionStorage.getItem('email')
      const password = sessionStorage.getItem('password')
      // Get email details
      axios({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getMessage',
        data: {
          account_id: accId,
          uid: uId,
          folder: folder,
          login: email,
          password: password
        }
      }).then(response => {
        var res = response.data
        if (res.success) {
          this.emailLoadingDialog = false
          this.emailDetailsData = res.data
          this.emailDetailsDialog = true
          this.emailLoading = true
          if (res.data.HtmlRaw.includes('img')) {
            this.displayImagesInEmail(mail, Uid)
          } else {
            setTimeout(() => {
              document.querySelector('.email-content').classList.remove('hide')
              this.emailLoading = false
            }, 1000)
          }
        }
      }).catch(err => {
        console.log(err)
      })
      if (!IsSeen) {
        this.seenEmail(Uid)
      }
      this.clear()
      this.emailLoadingDialog = true
    },
    displayImagesInEmail (mail, Uid) {
      // Get email images
      setTimeout(() => {
        var imgs = document.querySelectorAll('.email-text img')
        for (var i = 0; i < imgs.length; i++) {
          var imgSrc = imgs[i].src.split(':')
          var cid = imgSrc[1]
          this.imgSrcData.push(cid)
          this.setImageSrc(mail, Uid, imgs[i], this.imgSrcData[i], imgs.length, i)
        }
      }, 1000)
    },
    setImageSrc (mail, Uid, img, imgSrc, imgLength, imgCount) {
      var folder = ''
      if (mail === 'inbox') {
        folder = 'Inbox'
      } else if (mail === 'sent') {
        folder = 'Sent'
      }
      const accId = this.accountID
      const uId = Uid
      var cid = imgSrc
      const email = sessionStorage.getItem('email')
      const password = sessionStorage.getItem('password')
      axios({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getMessageCIDNew',
        data: {
          account_id: accId,
          uid: uId,
          folder: folder,
          cid: cid,
          login: email,
          password: password
        }
      }).then(response => {
        // var res = response.data
        // if (res.success) {
        //   img.src = res.data
        //   console.log(img.width)
        //   if (img.width <= 0 || img.width >= 1000) {
        //     img.style.width = '100%'
        //   }
        //   if (imgCount + 1 === imgLength) {
        //     document.querySelector('.email-content').classList.remove('hide')
        //     this.emailLoading = false
        //     // document.querySelector('.email-dialog').classList.remove('hide')
        //   }
        // }
        var res = response.data
        img.src = res
        console.log(response)
        if (img.width <= 0 || img.width >= 1000) {
          img.style.width = '100%'
        }
        if (imgCount + 1 === imgLength) {
          document.querySelector('.email-content').classList.remove('hide')
          this.emailLoading = false
          // document.querySelector('.email-dialog').classList.remove('hide')
        }
      }).catch(err => {
        console.log(err)
      })
      // document.querySelector('.email-dialog').classList.add('hide')
    },
    seenEmail (Uid) {
      const accId = this.accountID
      const uId = Uid
      // Get inbox
      axios({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/setMessagesSeen',
        data: {
          account_id: accId,
          uids: uId,
          seen: 'true',
          folder: 'Inbox'
        }
      }).then(response => {
        var res = response.data
        if (res.success) {
        }
      }).catch(err => {
        console.log(err)
      })
      if (document.querySelector('.mail-' + uId).classList.contains('read-false')) {
        document.querySelector('.mail-' + uId + '.read-false').classList.add('read-true')
        document.querySelector('.mail-' + uId + '.read-true').classList.remove('read-false')
      }
    },
    deleteEmail (uid) {
      const accId = this.accountID
      var emailFolder = ''
      if (this.activeTab === '1') {
        emailFolder = 'Inbox'
      } else if (this.activeTab === '2') {
        emailFolder = 'Sent'
      }
      // Delete Email
      axios({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/deleteMessages',
        data: {
          account_id: accId,
          uids: uid,
          folder: emailFolder
        }
      }).then(response => {
        var res = response.data
        if (res.success) {
        }
      }).catch(err => {
        console.log(err)
      })
    },
    clear () {
      this.recipientTo = []
      this.recipientCC = []
      this.recipientBCC = []
      this.responseForm = false
      this.inputRecipientToVisible = false
      this.recipientCCVisible = false
      this.recipientBCCVisible = false
      this.buttonResponseVisible = true
      this.subject = ''
      this.message = ''
      this.contactName = ''
      this.contactEmail = ''
    },
    closeEmailDetails () {
      this.clear()
      this.emailDetailsDialog = false
    },
    showReplyEmail (response, emailData) {
      this.responseForm = true
      const options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', literal: ':', hour: 'numeric', minute: 'numeric', second: 'numeric' }
      var emailText = document.querySelector('.email-text').innerHTML
      // Reply
      if (response === 'reply') {
        this.recipientTo.push(emailData.From['@Collection'][0].Email)
        this.subject = document.getElementById('textSubject').innerText
        this.message = '<br><br><div class="hide" dir="ltr">On ' + new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(emailData.TimeStampInUTC * 1000).slice(0, -5) + ' ' + emailData.From['@Collection'][0].DisplayName + ' &lt;<a href="" target="_blank" tabindex="-1" rel="external" class="external">' + emailData.From['@Collection'][0].Email + '</a>&gt; wrote:<br></div><blockquote class="hide" style="margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex"><u></u><div>' + emailText + '</div></blockquote>'
        // Reply All
      } else if (response === 'replyAll') {
        this.recipientTo.push(emailData.From['@Collection'][0].Email)
        for (var i = 0; i < emailData.Cc['@Collection'].length; i++) {
          this.recipientCC.push(emailData.Cc['@Collection'][i].Email)
        }
        this.subject = document.getElementById('textSubject').innerText
        this.message = '<br><br><div class="hide" dir="ltr">On ' + new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(emailData.TimeStampInUTC * 1000).slice(0, -5) + ' ' + emailData.From['@Collection'][0].DisplayName + ' &lt;<a href="" target="_blank" tabindex="-1" rel="external" class="external">' + emailData.From['@Collection'][0].Email + '</a>&gt; wrote:<br></div><blockquote class="hide" style="margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex"><u></u><div>' + emailText + '</div></blockquote>'
        this.recipientCCVisible = true
        // Forward
      } else if (response === 'forward') {
        this.recipientTo = []
        this.inputRecipientToVisible = true
        this.subject = 'Fwd: ' + document.getElementById('textSubject').innerText
        var ccList = ''
        if (emailData.Cc != null) {
          for (var j = 0; j < emailData.Cc['@Collection'].length; j++) {
            if (j > 0) {
              ccList += ', ' + emailData.Cc['@Collection'][j].Email
            } else {
              ccList += emailData.Cc['@Collection'][j].Email
            }
          }
          this.message = '<br><br><div class="hide">---- Original Message ----<br>From: ' + emailData.From['@Collection'][0].DisplayName + ' <<a href="">' + emailData.From['@Collection'][0].Email + '</a>><br>To: ' + emailData.To['@Collection'][0].DisplayName + ' <<a href="">' + emailData.To['@Collection'][0].Email + '</a>><br>CC: ' + ccList + '<br>Sent: ' + new Date(parseInt(emailData.TimeStampInUTC * 1000)).toLocaleDateString('en-US', options) + '<br>Subject: ' + emailData.Subject + ' <br><br>' + emailText + '</div>'
        } else {
          this.message = '<br><br><br><div class="hide">---- Original Message ----<br>From: ' + emailData.From['@Collection'][0].DisplayName + ' <<a href="">' + emailData.From['@Collection'][0].Email + '</a>><br>To: ' + emailData.To['@Collection'][0].DisplayName + ' <<a href="">' + emailData.To['@Collection'][0].Email + '</a>><br>Sent: ' + new Date(parseInt(emailData.TimeStampInUTC * 1000)).toLocaleDateString('en-US', options) + '<br>Subject: ' + emailData.Subject + ' <br><br>' + emailText + '</div>'
        }
      }
      this.buttonResponseVisible = false
    },
    showRecipient (recip) {
      if (recip === 'CC') {
        this.recipientCCVisible = true
        this.recipientCC = []
        this.inputRecipientCCVisible = true
        this.$nextTick(_ => {
          this.$refs.saveRecipientCC.$refs.input.focus()
        })
      } else if (recip === 'BCC') {
        this.recipientBCCVisible = true
        this.recipientBCC = []
        this.inputRecipientBCCVisible = true
        this.$nextTick(_ => {
          this.$refs.saveRecipientBCC.$refs.input.focus()
        })
      }
    },
    showInputRecipient (recip) {
      if (recip === 'to') {
        this.inputRecipientToVisible = true
        this.$nextTick(_ => {
          this.$refs.saveRecipientTo.$refs.input.focus()
        })
      } else if (recip === 'CC') {
        this.inputRecipientCCVisible = true
        this.$nextTick(_ => {
          this.$refs.saveRecipientCC.$refs.input.focus()
        })
      } else {
        this.inputRecipientBCCVisible = true
        this.$nextTick(_ => {
          this.$refs.saveRecipientBCC.$refs.input.focus()
        })
      }
    },
    addRecipient (recip) {
      if (recip === 'to') {
        let inputRecipientTo = this.inputRecipientTo
        if (inputRecipientTo !== '') {
          if (inputRecipientTo.includes('@')) {
            this.recipientTo.push(inputRecipientTo)
            if (this.recipientTo.length) {
              this.inputRecipientToVisible = false
              this.inputRecipientTo = ''
            }
            this.enableSendButton()
          } else {
            this.disableSendButton()
            this.$toastr('error', 'Ugyldig email')
          }
        } else {
          this.enableSendButton()
          this.inputRecipientToVisible = false
        }
      } else if (recip === 'CC') {
        let inputRecipientCC = this.inputRecipientCC
        if (inputRecipientCC !== '') {
          if (inputRecipientCC.includes('@')) {
            this.recipientCC.push(inputRecipientCC)
            if (this.recipientCC.length) {
              this.inputRecipientCCVisible = false
              this.inputRecipientCC = ''
            }
            this.enableSendButton()
          } else {
            this.disableSendButton()
            this.$toastr('error', 'Ugyldig email')
          }
        } else {
          this.enableSendButton()
          this.inputRecipientCCVisible = false
        }
      } else {
        let inputRecipientBCC = this.inputRecipientBCC
        if (inputRecipientBCC !== '') {
          if (inputRecipientBCC.includes('@')) {
            this.recipientBCC.push(inputRecipientBCC)
            if (this.recipientBCC.length) {
              this.inputRecipientBCCVisible = false
              this.inputRecipientBCC = ''
            }
            this.enableSendButton()
          } else {
            this.disableSendButton()
            this.$toastr('error', 'Ugyldig email')
          }
        } else {
          this.enableSendButton()
          this.inputRecipientBCCVisible = false
        }
      }
    },
    removeRecipient (val, recip) {
      if (recip === 'to') {
        this.recipientTo.splice(this.recipientTo.indexOf(val), 1)
        if (!this.recipientTo.length) {
          this.inputRecipientToVisible = true
        }
      } else if (recip === 'CC') {
        this.recipientCC.splice(this.recipientCC.indexOf(val), 1)
        if (!this.recipientCC.length) {
          this.recipientCCVisible = false
          this.inputRecipientCCVisible = true
        }
      } else {
        this.recipientBCC.splice(this.recipientBCC.indexOf(val), 1)
        if (!this.recipientBCC.length) {
          this.recipientBCCVisible = false
          this.inputRecipientBCCVisible = true
        }
      }
    },
    checkboxSelectDeselectAll () {
      var checkbox = document.querySelectorAll('.chkbx')
      if (document.getElementById('chkbxSelect').checked === true) {
        for (var i = 0; i < checkbox.length; i++) {
          checkbox[i].checked = true
        }
      } else {
        for (var j = 0; j < checkbox.length; j++) {
          checkbox[j].checked = false
        }
      }
      this.checkboxChanged()
    },
    markAsRead () {
      var uIds = []
      var checkboxes = document.querySelectorAll('.chkbx:checked')
      for (var i = 0; i < checkboxes.length; i++) {
        uIds.push(checkboxes[i].value)
      }
      for (var k = 0; k < uIds.length; k++) {
        const accId = this.accountID
        var uId = uIds[k]
        // Mark read all checked checkboxs
        axios({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/setMessagesSeen',
          data: {
            account_id: accId,
            uids: uId,
            seen: 'true',
            folder: 'Inbox'
          }
        }).then(response => {
          var res = response.data
          if (res.success) {
          }
        }).catch(err => {
          console.log(err)
        })
        if (document.querySelector('.mail-' + uId).classList.contains('read-false')) {
          document.querySelector('.mail-' + uId + '.read-false').classList.add('read-true')
          document.querySelector('.mail-' + uId + '.read-true').classList.remove('read-false')
        }
      }
    },
    markAsUnread () {
      var uIds = []
      var checkboxes = document.querySelectorAll('.chkbx:checked')
      for (var i = 0; i < checkboxes.length; i++) {
        uIds.push(checkboxes[i].value)
      }
      for (var k = 0; k < uIds.length; k++) {
        const accId = this.accountID
        var uId = uIds[k]
        // Mark read all checked checkboxs
        axios({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/setMessagesSeen',
          data: {
            account_id: accId,
            uids: uId,
            seen: 'false',
            folder: 'Inbox'
          }
        }).then(response => {
          var res = response.data
          if (res.success) {
          }
        }).catch(err => {
          console.log(err)
        })
        if (document.querySelector('.mail-' + uId).classList.contains('read-true')) {
          document.querySelector('.mail-' + uId + '.read-true').classList.add('read-false')
          document.querySelector('.mail-' + uId + '.read-false').classList.remove('read-true')
        }
      }
    },
    checkboxChanged () {
      var checkboxes = document.querySelectorAll('.chkbx:checked')
      if (!checkboxes.length) {
        document.querySelector('.mark-as').style.visibility = 'hidden'
      } else {
        document.querySelector('.mark-as').style.visibility = 'visible'
      }
    },
    tabChanged (tab) {
      if (tab.index === '0') {
        this.getEmailCount()
        this.inputSearchVisible = true
      } else if (tab.index === '1') {
        this.getEmailCount()
        this.inputSearchVisible = true
      } else if (tab.index === '2') {
        this.clear()
        this.inputSearchVisible = false
      } else if (tab.index === '3') {
        this.clear()
        this.inputSearchVisible = false
        this.displayContacts()
      }
      this.curPage = 1
      this.inputRecipientToVisible = true
      this.insideLoading = true
    },
    enableSendButton () {
      var sendButton = document.querySelectorAll('.send-btn')
      for (var i = 0; i < sendButton.length; i++) {
        sendButton[i].classList.remove('disabled')
      }
    },
    disableSendButton () {
      var sendButton = document.querySelectorAll('.send-btn')
      for (var i = 0; i < sendButton.length; i++) {
        sendButton[i].classList.add('disabled')
      }
    },
    displayContacts () {
      // Get contacts
      const email = sessionStorage.getItem('email')
      this.loginEmail = sessionStorage.getItem('email')
      const password = sessionStorage.getItem('password')
      axios({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getContacts',
        data: {
          login: email,
          password: password
        }
      }).then(response => {
        var res = response.data
        if (res.success) {
          this.contactsData = res.data
          this.insideLoading = false
        }
      }).catch(err => {
        console.log(err)
      })
      this.insideLoading = true
    },
    addContact () {
      // Add contact
      const contactName = this.contactName
      const contactEmail = this.contactEmail
      const email = sessionStorage.getItem('email')
      const password = sessionStorage.getItem('password')
      if (contactName !== '' && contactEmail !== '') {
        axios({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/createContact',
          data: {
            fullname: contactName,
            personal_email: contactEmail,
            personal_mobile: '',
            personal_address: '',
            login: email,
            password: password
          }
        }).then(response => {
          var res = response.data
          if (res.success) {
            this.enableSendButton()
            this.clear()
            this.closeContactForm('add')
            this.displayContacts()
            let obj = {
              title: 'Tilføjet!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          }
        }).catch(err => {
          console.log(err)
        })
        this.disableSendButton()
      } else {
        this.$toastr('error', 'Felter påkrævet')
      }
    },
    updateContact () {
      // Update contact
      const contactUuid = this.contactUuid
      const contactName = this.contactName
      const contactEmail = this.contactEmail
      const email = sessionStorage.getItem('email')
      const password = sessionStorage.getItem('password')
      if (contactName !== '' && contactEmail !== '') {
        axios({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/updateContact',
          data: {
            uuid: contactUuid,
            fullname: contactName,
            personal_mobile: '',
            personal_email: contactEmail,
            login: email,
            password: password
          }
        }).then(response => {
          var res = response.data
          if (res.success) {
            this.enableSendButton()
            this.clear()
            this.closeContactForm('update')
            this.displayContacts()
            let obj = {
              title: 'Opdateret!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          }
        }).catch(err => {
          console.log(err)
        })
        this.disableSendButton()
      } else {
        this.$toastr('error', 'Felter påkrævet')
      }
    },
    confirmDeleteContact (uuid) {
      return dialog => this.deleteContact(uuid)
    },
    deleteContact (uuid) {
      // Delete contact
      const email = sessionStorage.getItem('email')
      const password = sessionStorage.getItem('password')
      axios({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/deleteContacts',
        data: {
          uuids: uuid,
          login: email,
          password: password
        }
      }).then(response => {
        var res = response.data
        if (res.success) {
          this.displayContacts()
          let obj = {
            title: 'Slettet!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    showContactForm (option, contacts) {
      if (option === 'add') {
        this.contactsAddFormDialog = true
      } else if (option === 'update') {
        this.contactUuid = contacts.UUID
        this.contactName = contacts.FullName
        this.contactEmail = contacts.ViewEmail
        this.contactsUpdateFormDialog = true
      }
    },
    closeContactForm (option) {
      this.clear()
      if (option === 'add') {
        this.contactsAddFormDialog = false
      } else if (option === 'update') {
        this.contactsUpdateFormDialog = false
      }
    }
  },
  watch: {
    'search': function (newval, oldval) {
      if (this.activeTab === '1') {
        this.displayEmail('Inbox')
      } else if (this.activeTab === '2') {
        this.displayEmail('Sent')
      }
    }
  }
}
</script>
<style>
  #email .el-tabs__nav.is-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  #email .el-tabs__active-bar {
    display: none;
  }
  #email .el-tabs__nav-wrap::after {
    display: none;
  }
  #email .el-tabs__item {
    font-size: 16px;
    font-weight: normal;
  }
  #email .el-tabs__item:hover {
    color: #303133;
  }
  #email .el-tabs__item.is-active {
    color: #19a3c0!important;
  }
  #email .el-tabs__content .read-false .h6 {
    color: #003645;
    font-weight: 500;
  }
  #email .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #email .el-tag {
    display: inline-table;
    padding: 10px 10px;
    border-color: #d1d4d7;
  }
  #email .button-new-tag {
    background-color: #fff;
  }
  #email .el-tag .el-tag__close:hover {
    background-color: #19a3c0;
  }
  #email .el-dialog__header {
    padding: 30px 20px;
  }
  #email .el-dialog__header span {
    font-size: 2rem;
    color: #003645 !important;
    font-weight: 500;
  }
  #email .email-dialog .el-dialog__header {
    padding: 0;
  }
  #email button.el-dialog__headerbtn {
    display: none;
  }
  #email .el-dialog__body {
    font-size: 16px;
  }
/*  #email .el-dialog__body .recipient > span span:last-child span.coma {
    display: none
  }*/
  #email .email-text {
    height: 400px;
    overflow-y: auto;
  }
  #email .email-text a {
    pointer-events: none;
    color: grey !important;
  }
  #email .disabled {
    pointer-events: none;
    background-color: rgba(184, 195, 199, 0.5);
  }
  #email .mark-as a:after, #email .add-update-contact a:after, .auto-reload:after {
    display: none;
  }
  #email a.auto-reload {
    position: relative;
    left: -4px;
  }
  #email .el-table__body {
    border-collapse: collapse;
  }
  #email th.el-table_1_column_1.is-leaf {
    font-weight: normal;
    padding-bottom: 0.5rem;
  }
  #email [list]::-webkit-calendar-picker-indicator {
    display: none;
  }
  #email .dropzone .dz-preview.dz-image-preview {
    display: none;
  }
  #email .dropzone.dz-started .dz-message {
    display: block;
  }
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @media (max-width: 52em) {
    .clearfix.ml4 {
      margin-left: 0;
    }
    .el-dialog {
      width: 85% !important;
    }
    #email .el-tabs__nav.is-top {
      display: block;
    }
    #email .el-tabs__item {
      display: flex;
      left: 35%;
      padding-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// email.vue?2c811627